/**
 * This function is designed to resolve conflicts with the time setting for the 12 hour format.
 */
export function isTimeCheck(value: any): boolean {
	return /(^12:[0-5][0-9]?AM$)/i.test(value);
}
